import React from 'react';

export default {
  title: 'Connect to your Business Bank Account',
  leadParagraph:
    'Provide us with the last 6 months of your business transactions',
  ob: {
    heading: 'Instant one-time connection',
    paragraphs: () => [
      'Connecting your main business account is fast, easy and provides secure access to view your transactions.',
      'We only receive the historical transactions needed to get you an accurate price. Funding Circle will not continue to monitor your account.'
    ],
    notice:
      'Funding Circle has partnered with TrueLayer (an FCA regulated service) to provide connections to the following banks:',
    button: 'Connect to your bank'
  }
};
